import { uniqBy } from 'lodash';
import { helpers } from '../../common/lib';
import getInitialState from '../get-initial-state';
import { actionTypes } from './actions';

const initialState = {
  ...getInitialState.list(),
};

export default function (state = { ...initialState }, action) {
  switch (action.type) {
    case actionTypes.FINANCE_TYPE_ITEM_ADD: {
      return { ...state, item: getInitialState.financeType() };
    }
    case actionTypes.FINANCE_TYPE_ITEM_CLEAR: {
      return { ...state, item: null };
    }
    case actionTypes.FINANCE_TYPE_ITEM_SET: {
      const { financeType } = action.payload;
      return { ...state, item: financeType };
    }
    case actionTypes.FINANCE_TYPE_ITEM_UPDATE: {
      const { financeType } = action.payload;
      const { item } = state;
      return { ...state, item: { ...item, ...financeType } };
    }
    case actionTypes.FINANCE_TYPES_GET_REQUEST: {
      return { ...initialState };
    }
    case actionTypes.FINANCE_TYPES_GET_SUCCESS: {
      const { financeTypes } = action.payload;
      return helpers.getListReducer(state, financeTypes);
    }
    case actionTypes.FINANCE_TYPES_POST_SUCCESS: {
      const { financeTypes } = action.payload;
      return helpers.mergeListReducer(state, financeTypes);
    }
    case actionTypes.FINANCE_TYPE_PATCH_SUCCESS: {
      const { financeType } = action.payload;
      return helpers.getListItemReducer(state, financeType);
    }
    default: {
      return state;
    }
  }
}
